import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/manageStore";
import { AuthContext } from "../context/AuthContext";
import { FunctionalityNames } from "../enum/enum";
import { getPermissionRights } from "../utils/common";

const routePermissionMap = {
  "/dashboard": FunctionalityNames.DASHBOARD,
  "/job-list": FunctionalityNames.JOBLIST,
  "/candidate": FunctionalityNames.CANDIDATE,
  "/user": FunctionalityNames.USERS,
  "/settings": FunctionalityNames.SETTINGS,
  // Add more mappings as needed
};

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { rolePermissions } = useContext(AuthContext);

  // Check authentication
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Check permission for current route
  const pathname = location.pathname.split("/")[1] ? `/${location.pathname.split("/")[1]}` : location.pathname;
  const functionality = routePermissionMap[pathname];

  // If route is not mapped, treat as invalid URL
  if (!functionality && pathname !== "/") {
    return <Navigate to="/dashboard" replace />;
  }

  if (functionality && rolePermissions) {
    const perm = getPermissionRights(rolePermissions, functionality);
    if (!perm?.view) {
      // User is logged in but does not have permission for this page
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default PrivateRoute;